// extracted by mini-css-extract-plugin
export default {"contact":"product_contact__5NRSQ","title":"product_title__IPqcq","fields":"product_fields__nAkxo","field":"product_field__-4tuu","buttons":"product_buttons__c5fv1"};